indexHandler = {
  $smallFilterText      : $('.small-filter-text'),
  $smallFilterContainer : $('.small-filter-container'),
  $sortContainer        : $('.sort-container'),
  $sortItemContainer    : $('.sort-item-container'),
  $sortText             : $('.sort-text'),
  $sortSelected         : $('.selected-sort'),
  $filterItem           : $('.list-item-button'),
  $filterTitle          : $('.list-item-title'),
  $resultContainer      : $('.result-container'),
  $resultText           : $('.result-text'),
  $resultCount          : $('.result-count'),
  $resultSuffix         : $('.result-suffix'),
  $filterResult         : $('.filter-result-container'),
  $indexContainer       : $('.index-container'),
  $panelContent         : $('.panel-content-index'),
  $html                 : $('html'),
  $resetFilter          : $('[href="#reset-filter"]'),
  $pageIndex            : $('.page-template-page-index'),
  loadTimeout : null,
  isLoad : false, 

  reinitializeMasonry: function() {
    var $masonryContainer = this.$indexContainer.find('.panel-content-index').find('.masonry-container');
    $masonryContainer.imagesLoaded( function() {
      $masonryContainer.masonry({
        itemSelector: $(this).data('masonry-item'),
        columnWidth:  $(this).data('masonry-sizer'),
        percentPosition: true,
        transitionDuration: 0,
      });
      $masonryContainer.masonry('reloadItems');
    });
  },

  indexAjax: function($param) {
    var self = this;
    self.$indexContainer.find('.panel-content-index').empty();
    self.$indexContainer.find('.panel-content-index').addClass('loading-container');

    if (self.isLoad == false) {
      $.ajax({
        type: 'post',
        url: myAjax.ajax_url,
        data: {
          action: 'load_index_paging',
          page_index: $param['page_index'],
          sort_field: $param['sort_field'],
          sort_order: $param['sort_order'],
          filter_designer : $param['filter_designer'],
          filter_country  : $param['filter_country'],
          filter_keyword  : $param['filter_keyword'],
          filter_decade 	: $param['filter_decade'],
        },
        beforeSend: function(){
          self.isLoad = true;
          self.$resultText.addClass('hide');
          self.$resultCount.html('');
          self.$resultSuffix.html('');
        },
        success: function(response) {
          let $resultHtml = response['html'];
          self.$indexContainer.find('.panel-content-index').replaceWith($resultHtml);
          self.reinitializeMasonry();
          self.isLoad = false;

          var itemCount = self.$indexContainer.find('.panel-content-index').data('all-count');
          
          if (itemCount > 0) {
            self.$resultText.removeClass('hide');
            self.$resultCount.html(itemCount);

            if (itemCount > 1)
              self.$resultSuffix.html('s');
          }
        }
      });
    }
  },

  pagingOnClick : function($obj) {
    var self = this;
    var currIndex = $('.paging-num.is-current').data('paging-num');
    var pageIndex = $($obj).data('paging-num');
    
    if ($($obj).hasClass('next-num')) {
      pageIndex = currIndex+1;
    } else if ($($obj).hasClass('back-num')) {
      pageIndex = currIndex-1;
    }

    // A page of results is swapped in place, so the visitor is animated back to the top of the
    // page (same scroll as the "Apply Filter" submit) instead of being left at the paging links
    // with the new grid above the viewport. An absolute target is used on purpose: the grid is
    // emptied while loading, so any element-based offset would be measured in a collapsing page.
    $('html, body').animate({
      scrollTop : 0
    }, 'slow');

    if (currIndex != pageIndex) {
      // Paging reads the stored result set (searchHandler.resultIds): only the ids of the
      // requested page are posted, the collection query is not re-run.
      searchHandler.loadPage(pageIndex);
    }
  },

  filterSet : function() {
    var self = this;
    if (self.$filterItem.length > 0) {
      self.$filterItem.each(function() {
        var checked = $(this).prop("checked");
        if (checked == true)
          self.generateCloseItem($(this));
      });
    }
  },

  onClickItem : function($obj, isLoad = true) {
    searchHandler.setFilterState('page_index', 1);
    var self = this;
    var filterId    = ($obj.attr("id")) ? $obj.attr("id") : $obj.attr("for");
    var filterValue = $obj.val();
    var filterName  = $obj.attr("name");
    var type        = $obj.data("type");
    var $filterItemTemp = $obj;
    var checked         = $obj.prop("checked");

    /* if (filterId.indexOf('-small') == -1) {
      var $item = $('#'+filterId);
    } else {
      var $item = $('#'+filterId.replace('-small',''));
    }
      
    if ($item.length > 0) {
      $item.prop('checked', true);
    } */

    if (checked == true) {
      //self.generateCloseItem($obj);
      
    } else if (checked == false){
      var $resultItemTemp = $('.result-item[data-id="'+filterId+'"]');
      $resultItemTemp.remove();

      /* if (self.$resultContainer.find('.result-item').length == 0) {
        self.$filterResult.removeClass('is-show');
        self.$filterResult.find('.result-text').attr('tabindex', '-1');
        self.$filterResult.find('.result-text').attr('aria-hidden', 'true');
        self.$filterResult.find('.reset-button').attr('tabindex', '-1');
        self.$filterResult.find('.reset-button').attr('aria-hidden', 'true');
        searchHandler.indexHtml = '';
      } */
      searchHandler.setFilterState(type, filterValue, true);
    } 

    /* if (isLoad) {
      if (self.loadTimeout) clearTimeout(self.loadTimeout);
      self.loadTimeout = setTimeout(searchHandler.loadData(false, false, true), 1000);
      //self.updateUrl();
    } */
  },

  /**
   * Publish the applied state (filters, search term, sort, page) to the URL.
   *
   * The URL is the contract: it is what a refresh, a bookmark, a shared link, the browser back
   * button and the poster page's BACK button come back to.
   *
   * @param bool isReplace replace the current history entry instead of adding one (initial load,
   *                       paging, and corrections the visitor did not make)
   */
  updateUrl: function(isReplace = false){
    let params = [];

    // Filters come from the STATE, not from the chips: the state is what the query used and what the
    // URL was parsed into, so re-publishing the URL can never drop a filter (e.g. a term whose
    // checkbox is not rendered). The chips stay a UI element.
    let typeGroups = [];

    ['designer', 'country', 'keyword', 'decade'].forEach(function(filterType) {
      let values = [];

      (searchHandler.filterState || []).forEach(function(e) {
        if (!e || e.type !== filterType || !Array.isArray(e.value)) return;

        e.value.forEach(function(filterValue) {
          if (filterValue !== '' && values.indexOf(filterValue) < 0) values.push(filterValue);
        });
      });

      if (values.length > 0) {
        typeGroups.push({ type: filterType, values: values });
      }
    });

    if (typeGroups.length > 0) {
      params.push('type=' + typeGroups.map(function(group) { return group.type; }).join(','));
      params.push('id=' + typeGroups.map(function(group) { return group.values.join(','); }).join('-'));
    }

    // ?search-query=<text> — from the state, so it is the term the query actually used.
    var term = searchHandler.getFilterStateValue('search_term');

    if (term) {
      params.push('search-query='+encodeURIComponent(term));
    }

    // ?sort-field=<field>&sort-order=<ASC|DESC> — an empty field is the default order (Relevance).
    let sortField = searchHandler.getFilterStateValue('sort_field');
    let sortOrder = searchHandler.getFilterStateValue('sort_order');

    if (sortField) {
      params.push('sort-field='+sortField);
      params.push('sort-order='+sortOrder);
    }

    // ?page-index=<n> — only for pages other than the first, so a clean collection stays a clean URL.
    // A saved page whose posters are gone is clamped by the server and reconciled in loadData().
    // NOT `?page=`: that is a reserved WordPress query var, so redirect_canonical() 301s it away and
    // the collection loads without it (cline-context §12.31).
    let page = parseInt(searchHandler.getFilterStateValue('page_index'), 10);

    if (page > 1) {
      params.push('page-index='+page);
    }

    let url = window.location.origin+window.location.pathname;
    if (params.length > 0) {
      url += '?'+params.join('&');
    }

    if (isReplace) {
      window.history.replaceState("Posterhouse E-Museum", "Posterhouse E-Museum", url);
    } else {
      window.history.pushState("Posterhouse E-Museum", "Posterhouse E-Museum", url);
    }

    // The poster detail page reads this for its BACK button, so it can send the visitor back to the
    // exact list even when document.referrer is stripped.
    try {
      window.sessionStorage.setItem('phemuseum_collection_url', url);
    } catch (e) {}
  },

  /**
   * Point the sort control — and the in-memory state — at one option.
   *
   * A sort is a single choice, so whatever was selected before is dropped from the state. An empty
   * field is the server default (the relevance / random order), so it stays out of the state and
   * therefore out of the URL.
   *
   * @param string sortField '' for the default order, else title|designer|year
   * @param string sortOrder 'ASC' or 'DESC'
   */
  setSortSelection: function(sortField, sortOrder) {
    var self  = this;
    var $item = self.$sortItemContainer.find('.sort-item[data-sort-field="'+sortField+'"][data-sort-order="'+sortOrder+'"]').first();

    if ($item.length == 0) return;

    var previousField = searchHandler.getFilterStateValue('sort_field');
    var previousOrder = searchHandler.getFilterStateValue('sort_order');

    if (previousField) {
      searchHandler.setFilterState('sort_field', previousField, true);
    }

    if (previousOrder) {
      searchHandler.setFilterState('sort_order', previousOrder, true);
    }

    if (sortField) {
      searchHandler.setFilterState('sort_field', sortField);
      searchHandler.setFilterState('sort_order', sortOrder);
    }

    self.$sortSelected
      .data('sort-field', sortField)
      .data('sort-order', sortOrder)
      .text($item.text());
  },

  generateCloseItem: function($obj){
    var self = this;
    var filterId    = ($obj.attr("id")) ? $obj.attr("id") : $obj.attr("for");
    var filterValue = $obj.val();
    var filterName  = $obj.attr("name");
    var type        = $obj.data("type");

    if ($('.result-item[data-filter-value="'+filterValue+'"]').length == 0) {
      var $resultItemTemp = jQuery("<div data-filter-value="+filterValue+">"+filterName+"</div>")
      .attr({
        'class': 'result-item',
        'data-id': filterId,
        'tabindex': '0',
        'aria-label': 'Selected filter '+type+' '+filterName,
      });

      if (self.$resultContainer.find('.result-item').length == 0) {
        self.$filterResult.addClass('is-show');
        self.$filterResult.find('.result-text').attr('tabindex', '0');
        self.$filterResult.find('.result-text').attr('aria-hidden', 'false');
        self.$filterResult.find('.reset-button').attr('tabindex', '0');
        self.$filterResult.find('.reset-button').attr('aria-hidden', 'false');
      }

      if (self.$resultContainer.find('.result-item').length == 0 || self.$resultContainer.find('.result-item#'+filterId).length == 0) {
        $resultItemTemp.appendTo(self.$resultContainer);
        searchHandler.setFilterState(type, filterValue);
      }
    }
  },

  getUrlParameter: function(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  },

  loadByParams: function(){
    var self        = this;
    var queryParams = new URLSearchParams(window.location.search);

    // Only the collection index applies the collection URL params to the filters.
    if (self.$pageIndex.length == 0) {
      return;
    }

    // The URL is the ONLY source of state: start empty, then apply whatever the URL carries. No
    // params means nothing is preset, so /collection/ always opens clean (no stored state at all).
    searchHandler.resetFilterState();

    // ?search-query=<text> → search term
    if (queryParams.has('search-query')) {
      searchHandler.setFilterState('search_term', queryParams.get('search-query'));
    }

    // ?type=designer,keyword&id=12-345 → check the matching filter checkboxes (values are term ids)
    var typeParam   = queryParams.get('type');
    var idParam     = queryParams.get('id');
    var filterTypes = ['designer', 'country', 'keyword', 'decade'];

    if (typeParam && idParam) {
      var idValues = idParam.split('-');

      typeParam.split(',').forEach(function(type, key){
        if (filterTypes.indexOf(type) < 0) return;

        // One group per type, and a group can hold SEVERAL term ids: `?type=country,decade&id=14399-17429,17432`
        // means country 14399 plus decades 17429 and 17432 (the shape updateUrl() publishes).
        (idValues[key] || '').split(',').forEach(function(value){
          value = value.trim();

          if (!value) return;

          /*
           * Only ids the filter list can render are applied: an id without a checkbox points at a term
           * that no longer exists or has no published posters left (the accordion is built from
           * get_terms($taxonomy, ['hide_empty' => true]), see cline-context §7). Applying it would run
           * the query for nothing — an empty collection with no chip to remove — and updateUrl() would
           * keep re-publishing it. Dropping it here means the canonicalising updateUrl(true) in init()
           * rewrites the URL without it (replaceState, so no history entry for a correction the
           * visitor did not make).
           * NOTE: this relies on phemuseum_get_filter_lists() listing every available term. If that
           * list ever gets a number/paging limit, availability has to be validated server side.
           */
          var $obj = $('.list-item-button.filter-'+type+'[value="'+value+'"]');

          if ($obj.length == 0) {
            // Defensive: a stale chip for the same term from an earlier render would be orphaned.
            $('.result-item[data-id="'+type+'-'+value+'"]').remove();
            return;
          }

          searchHandler.setFilterState(type, value);

          $obj.prop('checked', true);
          $obj.each(function(){
            self.generateCloseItem($(this));
          });
        });
      });
    }

    // ?sort-field=year&sort-order=ASC → select that sort option
    var sortField = queryParams.get('sort-field');
    var sortOrder = queryParams.get('sort-order');

    if (sortField) {
      self.setSortSelection(sortField, sortOrder);
    }

    // ?page-index=<n> → which page of the result set to render (1 when absent or invalid). The server
    // clamps a page that no longer exists (posters deleted) and loadData() reconciles the URL after.
    // The name avoids WordPress' reserved `page`/`paged` query vars (cline-context §12.31).
    var pageParam = parseInt(queryParams.get('page-index'), 10);

    searchHandler.setFilterState('page_index', (pageParam > 1) ? pageParam : 1);

    // Any checkbox that is checked (markup default) gets its chip and state entry.
    self.$filterItem.each(function() {
      var checked = $(this).prop("checked");
      if (checked == true) {
        self.generateCloseItem($(this));
      }
    });
  },

  init: function() {
    var self = this;

    self.reinitializeMasonry();
    
    setTimeout(() => {
      $('[data-masonry]').masonry( 'layout' );
    }, 1000);

    $('body').on('click', function(e) {
      if (self.$smallFilterContainer.hasClass('is-show') && !$(e.target).hasClass('filter-inner-acc') && $(e.target).parents('.filter-inner-acc').length == 0 && !$(e.target).hasClass('small-filter-text') && $(e.target).parents('.small-filter-text').length == 0) {
        self.$smallFilterText.removeClass('is-active');
        self.$smallFilterContainer.removeClass('is-show');
      }

      if (self.$sortItemContainer.hasClass('is-show') && !$(e.target).hasClass('sort-inner-container') && $(e.target).parents('.sort-inner-container').length == 0 && !$(e.target).hasClass('sort-text') && $(e.target).parents('.sort-text').length == 0) {
        self.$sortText.removeClass('is-active');
        self.$sortItemContainer.removeClass('is-show');
      }
    });

    // ?clear-filters=1, the URL params and the pre-checked boxes are applied by loadByParams().

    $('[data-masonry]').masonry( 'on', 'layoutComplete', function() {
      $window.trigger("resize");
    });

    var itemCount = indexHandler.$indexContainer.find('.panel-content-index').data('all-count');
    if (itemCount > 0) {
      self.$resultText.removeClass('hide');
      self.$resultCount.html(itemCount);

      if (itemCount > 1)
        self.$resultSuffix.html('s');
    }

    self.$resetFilter.on('click', function(e){
      e.preventDefault();
      searchHandler.resetFilterState();
      searchHandler.$textSearchTerm.val('');
      self.$filterItem.prop('checked', false);
      self.$resultContainer.html('');

      // Reset also clears the sort and its direction: back to the default order (empty field) + ASC.
      self.setSortSelection('', 'ASC');

      self.updateUrl();
      searchHandler.indexHtml = '';
      searchHandler.loadData();
    });

    self.$indexContainer.on('click', '.paging-num', function(e) {
      e.preventDefault();
      self.pagingOnClick(this);
    });

    self.$smallFilterText.on('click', function(e) {
      
      if (self.$html.hasClass('disable-scroll')) {
        self.$html.removeClass('disable-scroll');
        self.$html.css({
          'padding-right' : '0px' 
        });
      } else {
        self.$html.addClass('disable-scroll');
        var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
          widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
        $outer.remove();
  
        var ScrollWidth = 100 - widthWithScroll;
        self.$html.css({
          'padding-right' : '-'+ScrollWidth+'px' 
        });
      }

      if (Foundation.MediaQuery.only('small')) {
        if (self.$sortText.hasClass('is-active')) {
          self.$sortText.click();
        }
      }

      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
        self.$smallFilterContainer.find('.accordion .filter-container').slideUp();
        self.$smallFilterContainer.find('.accordion .panel-filter-index').removeClass('is-active');
      } else {
        $(this).addClass('is-active');
      }

      if (self.$smallFilterContainer.hasClass('is-show')) {
        self.$smallFilterContainer.removeClass('is-show');
      } else {
        self.$smallFilterContainer.addClass('is-show');
      }
    });

    self.$sortText.on('click', function(e) {
      e.preventDefault();

      if (Foundation.MediaQuery.only('small')) {
        if (self.$smallFilterText.hasClass('is-active')) {
          self.$smallFilterText.click();
        }
      }

      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
      } else {
        $(this).addClass('is-active');
      }

      if (self.$sortItemContainer.hasClass('is-show')) {
        self.$sortItemContainer.removeClass('is-show');
      } else {
        self.$sortItemContainer.addClass('is-show');
      }
    });

    self.$sortItemContainer.find('.sort-item').on('click', function(e) {
      e.preventDefault();
      var sortField = $(this).data('sort-field');
      var sortOrder = $(this).data('sort-order');
      var selSortField  = self.$sortSelected.data('sort-field');
      self.$sortItemContainer.removeClass('is-show');
      self.$sortText.removeClass('is-active');
      
      if (sortField != selSortField) {
        self.setSortSelection(sortField, sortOrder);

        // A new sort is a new result set: back to page 1.
        searchHandler.setFilterState('page_index', 1);
        // The sort is part of the URL, so a refresh/back returns to the same ordering.
        self.updateUrl();
        searchHandler.loadData();
      }
    });

    self.$filterItem.on('click', function() {
      self.onClickItem($(this), true);
    });

    $(document).on('click', '.result-item', function(){
      var filterVal    = $(this).data('filter-value');
      var $objListItem = $('.list-item-button[value="'+filterVal+'"]');
      var $objItem     = $('.result-item[data-filter-value="'+filterVal+'"]');
      var type         = $objListItem.data('type');
      
      $objItem.remove();
      $objListItem.prop("checked", false);

      if (self.$resultContainer.find('.result-item').length == 0) { 
        self.$filterResult.removeClass('is-show');
        self.$filterResult.find('.result-text').attr('tabindex', '-1');
        self.$filterResult.find('.result-text').attr('aria-hidden', 'true');
        self.$filterResult.find('.reset-button').attr('tabindex', '-1');
        self.$filterResult.find('.reset-button').attr('aria-hidden', 'true');
        searchHandler.indexHtml = '';
      }
    
      searchHandler.setFilterState('page_index', 1);
      searchHandler.setFilterState(type, ''+filterVal+'' , true);
      self.updateUrl();
      searchHandler.loadData();
    });

    self.loadByParams();

    // The index template ships an empty result area, so the first page is fetched here — after the
    // URL params have been applied to the checkboxes, the search box and the sort control.
    if (self.$indexContainer.length > 0) {
      // Page 1 unless the URL asked for another page (loadByParams() already put it in the state).
      searchHandler.loadData(true, true);

      // Canonicalize the URL from the applied state (drops e.g. a legacy ?clear-filters=1) and store
      // it for the poster detail page's BACK button.
      self.updateUrl(true);
    }

    // Browser back/forward inside the collection re-applies the URL, so the history buttons behave
    // like the poster page's BACK button and the grid never goes stale behind the URL.
    $(window).on('popstate', function(){
      if (self.$indexContainer.length == 0) return;

      self.loadByParams();
      searchHandler.loadData(true, true);
      self.updateUrl(true);
    });

    $('.filter-form').on('submit', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, 'slow');

      if ($(this).parents('.small-filter').length > 0) {
        self.$smallFilterText.click();
      }

      searchHandler.loadData();
      self.updateUrl();
    });
  }
}